module.exports = __webpack_public_path__ + "img/img_demo_shoushi@2x.cbe1ce13.png";